@let _activeArtifact = artifacts.activeArtifact();
@let _list = artifacts.list();

@for (_artifact of _list; track _artifact.nodeId) {
	@let _isActive = _artifact.nodeId === _activeArtifact.nodeId;
	@let _iteration = $index - _list.length | adaMathAbs;
	@let _artifactKey = `${(_artifact.responseType | titlecase)} ${_iteration}`;

	<button
		class="ada-llm-artifact-list-entry ada-container ada-flex-align-start ada-flex-justify-between ada-btn-flex ada-border-bottom"
		data-testid="ada-llm-artifact-list-entry"
		style.padding="{{ ui.Spacing.SPACING_MEDIUM }}"
		[class.ada-background-color-background-2]="!_isActive"
		[class.ada-background-color-primary-alpha-25]="_isActive"
		[class.ada-border-inner-left-primary-3px]="_isActive"
		(click)="onArtifactClicked(_artifact)"
	>
		<div
			ada-color="foreground"
			class="ada-container ada-colspan-1 ada-flex-column"
			[style.gap]="ui.Spacing.SPACING_SMALL"
			[style.width]="'100%'"
		>
			<div
				ada-font-weight="bold"
				class="ada-display-flex ada-llm-artifact-list-entry-heading"
				[style.gap]="ui.Spacing.SPACING_SMALL"
			>
				@let _artifactName = (_artifact | adaLlmArtifactName | async) || _artifactKey;
				<span
					class="ada-ellipsis-overflow"
					[style.white-space]="'nowrap'"
					[title]="_artifactName"
				>
					{{ _artifactName }}
				</span>
				@if (_isActive) {
					<div
						class="ada-container ada-container-nowrap ada-flex-justify-between ada-flex-grow"
						[style.column-gap]="ui.Spacing.SPACING_SMALL"
					>
						<ada-search-tag
							class="ada-inline"
							text="Current"
							[isCloseButtonVisible]="false"
						/>
						<button
							aria-label="More options"
							class="ada-artifact-menu-btn ada-btn ada-btn-flat ada-btn-icon ada-btn-small ada-btn-no-margin ada-btn-no-padding"
							title="More options"
							[adaContextMenuTrigger]="Menu"
							[adaMenuTrigger]="Menu"
							[adaMenuTriggerData]="_artifact"
						>
							<ada-icon
								ada-type="base"
								color="primary"
								icon="faEllipsisH"
							/>
						</button>
					</div>
				}
			</div>

			<span
				ada-opacity="50"
				ada-type="small"
				class="ada-text-align-left"
			>
				<span ada-font-weight="bold">{{ _artifactKey }} &middot;</span>
				{{ _artifact.llmResponseReceivedTimestamp | adaLocalizedDate: 'short' }}
			</span>
		</div>
	</button>
} @empty {
	<ada-alert
		class="ada-full-width"
		data-testid="ada-llm-artifact-list-empty-alert"
		padding="{{ ui.Spacing.SPACING_LARGE }}"
		[isClosable]="false"
		[title]="'No artifacts yet'"
	/>
}

<ada-menu
	#Menu
	[controller]="menuController"
/>
